import { render } from "./MiaDashboard.vue?vue&type=template&id=5bbe8a12&scoped=true"
import script from "./MiaDashboard.vue?vue&type=script&lang=js"
export * from "./MiaDashboard.vue?vue&type=script&lang=js"

import "./MiaDashboard.vue?vue&type=style&index=0&id=5bbe8a12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbe8a12"]])

export default __exports__